<template lang="pug">
  .feature
    img.img(:src="imgsrc")
    .text
      //- h4.fz-h-l.t-center 丰富的组件库
      h4.lh-h.fz-l.f-z-h-l.t-center {{title}}
      //- p.p.fz-p-m.color-text-2 从文字、插画，到表单和服务，各类组件让内容更具生命力。实现你意想不到的所有功能。
      p.p.lh-p.fz-m.f-z-p-m.color-text-2.t-center {{paragraph}}
</template>

<script>
export default {
  name: "feature",
  props: {
    imgsrc: "",
    title: {
      type: String,
      default: "Change title"
    },
    paragraph: {
      type: String,
      default: "Change main content"
    }
  }
};
</script>

<style lang="stylus" scoped>
@require '../styles/layout/main'
@require '../styles/design/main'

.feature
  stack(y, gap: .5rem, ali: center)
.img
  width 360px
  max-width 100%
.text
  stack(y, gap: 1rem)
  width 80% //320px
  max-width 420px

</style>
